import axios from 'axios';

axios.defaults.baseURL = process.env.VUE_APP_ENDPOINT;
axios.defaults.auth = {
    username: process.env.VUE_APP_HTTP_USERNAME,
    password: process.env.VUE_APP_HTTP_PASSWORD
};

export default {
    /**
     * Fetches the campaign meta-data
     * @param {String|Number} [id] - optional landing page id, specified in a query string
     * @returns {Promise}
     */
    getMeta(id) {
        return axios.get('access-codes/landingpage/' + id);
    },

    /**
     * Sends the user data
     * @param {Object} form
     * @returns {Promise}
     */
    requestCode(form) {
        return axios.post('access-codes/request-code', form);
    }
};
